<div class="d-flex gap-2 justify-content-center m-1">  
    <!-- Edit Button -->
    <button class="btn btn-sm btn-outline-primary" (click)="onEdit()" title="Edit" >
      <i class="bi bi-pencil"></i>
    </button>
    
    <!-- Delete Button -->
    <button class="btn btn-sm btn-outline-danger" (click)="onDelete()" title="Delete" readOnlyIfNoGroupPermissionDirective [showToastWhenRendering]="false">
      <i class="bi bi-trash"></i>
    </button>
    
    <!-- Details Button -->
    <button class="btn btn-sm btn-outline-info" (click)="onMove()" title="Move" readOnlyIfNoGroupPermissionDirective [showToastWhenRendering]="false">
      <i class="bi bi-arrows-move"></i>
    </button>
    </div>
    